import { AfterContentChecked, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { Subscription } from 'rxjs';
import { MenuItemService } from '../sidebar/sidebar.service';
import { AuthService } from '../../infrastructure/config/msal-config/auth.service';
import { OrganizationSearchComponent } from '../organization-search/organization-search.component';
import { PortalAccount } from '../../feature/account/PortalAccount';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    OrganizationSearchComponent,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatGridListModule
  ]
})
export class NavComponent implements OnDestroy, AfterContentChecked, OnInit {

  navSubscription = new Subscription();
  loggedInUser: PortalAccount | undefined;
  loggedIn: boolean = false;
  mobileQuery: MediaQueryList;
  changeDetectorRef: ChangeDetectorRef;

  private _mobileQueryListener: () => void;

  constructor(
    private readonly router: Router,
    public readonly authService: AuthService,
    private readonly menuItemService: MenuItemService
  ) {
    this.changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher);

    this.mobileQuery = media.matchMedia('(max-width: 630px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener("change", this._mobileQueryListener, {passive: true});
  }

  ngOnInit(): void {
    this.changeDetectorRef.markForCheck();
  }

  ngAfterContentChecked(): void {
    this.loggedIn = false;
    this.navSubscription.add(this.authService.portalAccount$.subscribe((user: PortalAccount | undefined) => {
      if (user != null) {
        this.loggedIn = true;
        this.loggedInUser = user;
      }
    }));
  }

  ngOnDestroy(): void {
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
  }

  isRouteHome(): boolean {
    if (!this.router) {
      return false;
    }
    return this.router.url === "/";
  }

  isComponentRouteSearchable(): boolean {
    if (!this.router) {
      return false;
    }

    return true;
  }

  isComponentOrganizationSortable(): boolean {
    if (!this.router) {
      return false;
    }

    if (
      this.router.url === "/organizations" || 
      this.router.url === "/policies" ||
      this.router.url === "/price-rates" ||
      this.router.url === "/verification-packages" ||
      this.router.url === "/underwriters" ||
      this.router.url === "/bad-guests" ||
      this.router.url === "/referrals"
    ) {
      return true;
    } else {
      return false;
    }
  }

  goToHome() {
    this.router.navigate(["/"]);
  }

  logout() {
    this.authService.logout();
  }

  onToggleSideNav() {
    this.menuItemService.toggle();
  }
}